import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import InternalAuditFindingForm from 'src/pages/internal-audit/reports/forms/InternalAuditFindingForm';
import type { ObjectWithContributors } from 'src/rbac/Permission';

import { internalAuditReportResultsUrl } from '@/utils/urls';

interface Props {
  assessment?: ObjectWithContributors;
}

const InternalAuditResultCreateTab: FC<Props> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['common']);
  const assessmentId = useGetGuidParam('assessmentId');
  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(internalAuditReportResultsUrl(assessmentId));
    }
  };

  return (
    <InternalAuditFindingForm
      readonly={!props.assessment}
      parentAssessment={props.assessment}
      onDismiss={onDismiss}
      assessmentId={assessmentId}
      formType={location.state?.type}
      ratingResultType={location.state?.ratingType}
      preselectedAssessedItemIds={location.state?.ids}
      navigateToResults={true}
      showAssessmentSelector={true}
      header={t('details')}
    />
  );
};

export default InternalAuditResultCreateTab;
